import { render } from "./ViewDePruebas.vue?vue&type=template&id=033b432a&scoped=true"
import script from "./ViewDePruebas.vue?vue&type=script&lang=js"
export * from "./ViewDePruebas.vue?vue&type=script&lang=js"

import "./ViewDePruebas.vue?vue&type=style&index=0&id=033b432a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033b432a"]])

export default __exports__